import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

// Define props used for dynamic styles
interface StyleProps {
  isMobile?: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  counterContainer: ({ isMobile }) => ({
    width: isMobile ? "65%" : "182px",
    backgroundColor: theme.palette.gray30.main,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 6,
  }),
  myTimeCounterContainer: {
    width: "204px",
    backgroundColor: theme.palette.gray30.main,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 6,
  },
  counter: {
    fontSize: "96px",
    lineHeight: "120px",
    letterSpacing: -1.5,
    color: theme.palette.primary.main,
  },
  workTimeCounter: {
    fontSize: "64px",
    lineHeight: "120px",
    letterSpacing: -1.5,
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
